<template>
  <div>
    <v-app class="p-4">
      <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="editModal"
              max-width="900"
              hide-overlay
              transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar
                  flat
                  dark
                  color="primary"
              >

                <v-toolbar-title>ویرایش آگهی پیشفرض</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="editModal = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>

              <EditAdvertise :modal="()=>{this.editModal=false}" v-if="editModal" type="default"
                             :token="editProps"></EditAdvertise>
              <!--<edit-def v-if="editModal" :modal="()=>{this.editModal=false}" :edit-token="editProps"></edit-def>-->
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->
      <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="chooseNumber"
              max-width="900"
              hide-overlay
              transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar
                  flat
                  dark
                  color="primary"
              >

                <v-toolbar-title>انتخاب شماره برای ارسال آگهی</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="chooseNumber = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <div class="col-md-11 mx-auto justify-content-center py-10 px-0">
                <div class="mx-auto">
                  <div class="col-md py-0">
                    <v-checkbox
                        v-model="noNumber"
                        label="ارسال آگهی سریع اتوماتیک"
                        color="indigo"
                        value="noNumber"
                        hide-details
                    ></v-checkbox>
                  </div>
                  <div class="col-md">
                    <v-checkbox
                        v-model="noNumber"
                        label="ارسال آگهی سریع باانتخاب شماره"
                        color="indigo"
                        value="number"
                        hide-details
                    ></v-checkbox>
                    <div v-if="noNumber === 'number' ">
                      <p>برای ارسال آگهی خود باید شماره ای انتخاب کنید.</p>
                      <number-selector :key="chooseNumber" :force="true"
                                       :multiple-numbers="false">
                      </number-selector>
                    </div>
                  </div>
                </div>
                <v-btn v-if="noNumber ==='number' " class="submit-btn mt-5" @click="quickSend">
                  <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                  ارسال سریع
                </v-btn>
                <v-btn v-else class="submit-btn mt-5" @click="sendWithNumber">
                  <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                  ارسال اتوماتیک
                </v-btn>

                <div>
                </div>
              </div>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->
      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
        <div class="mt-5 pt-5">
          <router-link to="/sendADS/default">
            <v-btn class="btn-add-with-text">
              <span class="fa fa-plus ml-1"></span>
              ایجاد آگهی پیشفرض
            </v-btn>
          </router-link>
          <v-card :loading="loading" class="p-3 pt-0 mt-4">

            <terminal-table :currentPage="datas.current_page"
                            :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                            :pageCount="datas.last_page"
                            :options="tableProps" :datas="datas" :headers="columns"></terminal-table>


            <data-table
                v-else
                :data="datas"
                :columns="columns"
                :debounce-delay="3000"
                :translate="translate"
                :pagination="paginate"
                :orderBy="tableProps.column"
                :orderDir="tableProps.dir"
                :per-page="[10, 25, 50, 100, 500]"
                @on-table-props-changed="reloadTable"
                class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                               v-model="searchBox"></filters-table>
              </template>
            </data-table>
            <div class="col-md-8 mx-auto" v-if="Object.keys(datas).length > 0">
              <v-alert
                  v-if="datas.data.length == 0"
                  text
                  outlined
                  color="deep-orange"
                  class="text-center"
                  icon="error"
              >
                برای استفاده از ارسال سریع، باید ابتدا آگهی پیشفرض ثبت نمایید.
              </v-alert>
            </div>
          </v-card>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import {Bus, dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import CreateDefault from "@/view/pages/ads/default/createDefault";
import EditSimple from "@/view/pages/ads/singleAds/editSimple";
import EditDef from "@/view/pages/ads/singleAds/editDef";
import {debounce} from "../../../../custom";
import NumberSelector from "@/view/pages/ads/numberSelector";
import EditAdvertise from "../Edit/Advertise";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "deafultAdsList",
  components: {
    FiltersTable,
    EditAdvertise, NumberSelector, EditDef, EditSimple, CreateDefault, TitleRibbon, button, dataTableProps, createTarefe
  },
  props: {
    editProps: {
      type: Number,
      default: ''
    }
  },
  data() {
    return {
      tarafeName: "",
      chooseNumber: false,
      editModal: false,
      loading: false,
      noNumber: 'noNumber',
      translates: [],
      chosen_num: '',
      city: '',
      category: '',
      title: '',
      datas: {},
      translate: dataTableProps.translate,
      paginate: dataTableProps.pagination,
      tableProps: dataTableProps.tableProps,
      url: `${url}/default`,
      selectedNumber: [],
      dataId: '',
      fastId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'دسته آگهی',
          name: 'data.advertise.category',
          transform: (val) => {
            return this.translator(val.data.data.advertise.category);
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'موضوع',
          name: 'data.advertise.title',
          primary: true,
          transform(val) {
            const color = {
              "paid": 'danger',
              "rejected": 'warning',
              "enabled": 'success',
              "disabled": 'secondary',
            }
            if (this.isMobile)
              return `<span class="badge badge-${color[val.data.status]} mt-2">${val.data.data.advertise.title}</span>`
            else return `${val.data.data.advertise.title}`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'شهر',
          name: 'data.advertise.location.city',
          transform: (val) => {
            return this.translator("city_" + val.data.data.advertise.location.city);
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'ارسال سریع',
          name: 'action',
          transform: (val) => {
            return `<button class="btn btn-sm btn-primary text-center fastForward fa fa-paper-plane text-center" ${val.data.status === 'disabled' || val.data.status == "paid" || val.data.status == "rejected" ? "disabled" : ""} data-id="${val.data.id}" data-title="${val.data.data.advertise.title}" data-category="${val.data.data.advertise.category}" data-city="${val.data.data.advertise.location.city}"></button>`
          },
        },
        {
          label: 'تعداد انتشار',
          name: 'action',
          transform: (val) => {
            return `<span class="badge badge-info mt-2">${val.data.assessed != null ? val.data.assessed : 0}</span>`
          },
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            permission_prefix: 'notification_',
            buttons: [
              {
                name: 'edit',
                label: 'ویرایش',
                icon: 'pencil-alt',
                class: 'btn-outline-warning',
                action: this.actions,
                status: 'default_update',
                condition(status) {
                  return status !== "disabled";
                }
              },
              {
                name: 'delete',
                label: 'حذف آگهی',
                icon: 'trash-alt',
                class: 'btn-outline-danger',
                action: this.actions,
                status: 'default_delete',
                condition(status) {
                  return true
                }
              },
              // {
              //     name: 'sendWithNum',
              //     label: 'ارسال سریع با انتخاب شماره',
              //     icon: 'paper-plane',
              //     class: 'btn-outline-primary',
              //     action: this.actions,
              //     status: 'default_delete',
              //     condition: this.buttonsCondition
              //
              // },
            ]
          }
        }
      ],
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.datas = data;
          vm.loading = false
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
    translator(name) {
      return this.translates[name];
    },
    actions(data, type) {
      if (type === 'edit') {
        this.editModal = true;
        this.editProps = data.id
      } else if (type === 'delete') {
        this.$modal.yesNo('تایید حذف', 'آیا از حذف این دسته اطمینان دارید؟', "neg", '').then((value => {
          if (value === true) {
            $.ajax({
              url: `${url}/default/${data.id}`,
              type: "DELETE",
              fn: this.actions,
              params: [data, type],
              msg: true,
              headers: {
                ACCEPT: 'application/json',
                'Content-Type': 'application/json',
                Authorization: Token
              },
              success: (res) => {
                this.reloadTable();
              }
            })
          }
        }))
      }
    },
    getLocalization() {
      if (localStorage.getItem('localization')) {
        this.translates = JSON.parse(localStorage.getItem('localization'));
        return;
      }
      $.ajax({
        url: `${url}/setting/localization`,
        type: 'GET',
        fn: this.getLocalization,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: (data) => {
          this.translates = data
          localStorage.setItem('localization', JSON.stringify(data));
        }
      })
    },

    quickSend() {
      if (this.chosen_num !== '') {
        this.$modal.showLoading();
        $.ajax({
          url: `${url}/divar/check/title`,
          type: "POST",
          fn: this.authenticate,
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
            "Content-type": 'application/json'
          },
          data: JSON.stringify({
            "title": this.title,
            "city": String(this.city),
            "category": this.category
          }),
          msg: false,
          error: (data) => {
            if (data.status === 422) {
              this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
            } else {
              this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
            }
          },
          success: (data) => {
            this.$nextTick(function () {
              this.$modal.success(data.message);
            });
            $.ajax({
              url: `${url}/divar/fast/forward/${this.fastId}`,
              type: 'POST',
              fn: this.quickSend,
              msg: true,
              reload_table: this.reloadTable,
              headers: {
                Authorization: Token,
                ACCEPT: 'application/json',
                "Content-type": "application/json"
              },
              data: JSON.stringify({phone: this.chosen_num}),
              success: (res) => {
                this.chooseNumber = false;
                this.noNumber = 'noNumber'
              }
            })
          }
        });
      }
    },
    sendWithNumber() {
      if (this.chosen_num === '' && this.noNumber === 'noNumber') {
        this.$modal.showLoading();
        $.ajax({
          url: `${url}/divar/check/title`,
          type: "POST",
          fn: this.authenticate,
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
            "Content-type": 'application/json'
          },
          data: JSON.stringify({
            "title": this.title,
            "city": String(this.city),
            "category": this.category
          }),
          msg: false,
          error: (data) => {
            if (data.status === 422) {
              this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
            } else {
              this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
            }
          },
          success: (data) => {
            this.$nextTick(function () {
              this.$modal.success(data.message);
            });
            $.ajax({
              url: `${url}/divar/fast/forward/${this.fastId}`,
              type: 'POST',
              fn: this.sendWithNumber,
              reload_table: this.reloadTable,
              msg: true,
              headers: {
                Authorization: Token,
                ACCEPT: 'application/json',
                "Content-type": "application/json"
              },
              success: (res) => {
                $('.fastForward').unbind();
                this.chooseNumber = false;
              }
            })
          }
        });
      }
    },
    buttonsCondition(status) {
      return [
        "paid", "rejected", "disabled"
      ].indexOf(status) <= -1;
    },
  },
  watch: {
    noNumber: function (val) {
      if (val === "noNumber") {
        this.chosen_num = ''
      }
    },
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }

  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.tableProps = {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
        page: 1,
      };
      this.getDataForTable(this.url);
      this.getLocalization();
    });

    Bus.$on('selected_numbers', (value) => {
      this.chosen_num = value
    });

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    });

    let fastForward = (element) => {
      this.chooseNumber = true
      this.fastId = element.target.dataset.id;
      this.city = element.target.dataset.city;
      this.category = element.target.dataset.category;
      this.title = element.target.dataset.title;

    }
    $(document).on('click', `.fastForward`, fastForward);
  },
}
</script>

<style scoped>

</style>